module.exports = __webpack_public_path__ + "img/v_logo.5bff7a87.png";